<div class="text-center" style="background-color: #fff;">
	<div class="float-end" style="padding:10px;">
		<span class="jmCloseBtn" (click)="close($event)"></span>
	</div>
	<!-- Bottom of the header -->
	<div style="padding-top: 150px; padding-left: 5px;">
		<div><h3 style="font-size: 40px; padding:10px 0px;">This feature is on its way!</h3></div>
	</div>

	<!-- MODAL BODY -->
	<div style="padding-top: 0px; overflow: hidden;">
		<div class="row">
			<div class="col-12 text-center">Love Journeys? Then you'll love what is coming next.</div>
		</div>
		<br />
		<div class="row">
			<div class="col-12 text-center">
				<button (click)="close($event)" class="btn btn-lg btn-primary">Got it! Take me back.</button>
			</div>
		</div>
	</div>

	<!-- Clouds logo -->
	<div class="col-12" style="padding-left: 0; padding-right: 0;">
		<img src="assets/images/clouds.png" class="zoomImg" style="width:100%; left:0;">
	</div>
</div>
